module.exports = __webpack_public_path__ + "fonts/Gibson-BoldItalic.0af6911e.woff";